import { byKind, BranchRenderProps } from '../columns/createPlanColumn';
import type { Column } from 'components/DataGrid';
import type { GridRow, GridSummaryRow, RowOrGroup } from '../../types';
import type { Calendar } from './types';
import { Header } from './Header';
export { useCalendar } from './useCalendar';
import { Edit } from './Edit';
import { View } from './View';
import { column } from './style.css';

export function createCalendarColumn(calendar: Calendar): Column<RowOrGroup, GridSummaryRow> {
  const view = (props: BranchRenderProps<GridRow>) =>
    props.cellState.locked ? (
      <View {...props} calendar={calendar} />
    ) : (
      <Edit {...props} calendar={calendar} key={props.row.modified_at} />
    );

  const positionsBranch = { field: 'positions' as const, view };

  return byKind({
    key: 'positions',
    name: <Header calendar={calendar} />,
    width: calendar.width,
    className: column,
    branches: {
      media: positionsBranch,
      service: positionsBranch,
    },
  });
}
